'use client';

import type { PropsWithChildren, ReactNode } from 'react';
import * as PopoverComponent from '@radix-ui/react-popover';

export type PopoverProps = {
	className?: string;
	trigger: ReactNode;
};

export function Popover(props: PropsWithChildren<PopoverProps>) {
	return (
		<div className={props.className}>
			<PopoverComponent.Root>
				<PopoverComponent.Trigger asChild>{props.trigger}</PopoverComponent.Trigger>
				<PopoverComponent.Portal>
					<PopoverComponent.Content side='top' sideOffset={5}>
						<div
							className={
								'p-4 rounded-[0.5rem] flex flex-col gap-2 bg-background-primary relative max-w-md w-[calc(100vw-var(--container-padding)-var(--container-padding))] before:content-[""] before:absolute before:top-0 before:left-0 before:right-0 before:bottom-0 before:bg-background-secondary/10 before:rounded-[0.5rem]'
							}
						>
							{props.children}
						</div>
						<PopoverComponent.Arrow className={'fill-background-secondary/10'} />
					</PopoverComponent.Content>
				</PopoverComponent.Portal>
			</PopoverComponent.Root>
		</div>
	);
}
